export default __webpack_public_path__ + "static/media/Background_00151.93085ccb.png";